<div class="skeleton-row">
  <div class="skeleton cell w-10"></div>
  <div class="skeleton cell w-20"></div>
  <div class="skeleton cell w-15"></div>
  <div class="skeleton cell w-25"></div>
  <div class="skeleton cell w-15"></div>
</div>


